import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Typography } from "@mui/material";
import theme from "../../theme";
import { Add } from "@mui/icons-material";
import CommonButton from "../../common/components/CommonButton";
import AddParentAccount from "../ParentAccount/AddParentAccount";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getParents } from "../../api/parentApi";
import { setParentList } from "../../features/parentSlice";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { UserTypeId } from "../../common/const";

const ParentAccess = () => {
    const dispatch = useDispatch();
    const { user, loading } = useSelector((state) => state.auth);
    const { parentList } = useSelector((state) => state.parent);
    const [addOpen, setAddOpen] = useState(false);

    const getParentList = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getParents(user?.student_id);
            dispatch(setParentList({
                list: response.data
            }));
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            getParentList();
        }
    }, [user?.student_id]);

    return (
        <Fragment>
            <AddParentAccount
                addOpen={addOpen}
                setAddOpen={setAddOpen}
                getParentList={getParentList}
            />
            {loading && (
                <LoadingSpinner />
            )}
            <CommonCard
                borderRadius={2}
                border={`1px solid ${theme.palette.background.secondary}`}
                headerContent={
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mr={1}
                    >
                        <Box sx={{ padding: '13px' }}>
                            <Typography fontWeight={600}>Parent Access</Typography>
                            <Typography fontSize={14} color={theme.palette.background.dark}>Manage and view linked parent accounts.</Typography>
                        </Box>
                        {user?.user_type_id === UserTypeId.Student && (
                        <CommonButton
                            label="Add Another Parent"
                            marginBottom="0px"
                            width="220px"
                            background={theme.palette.background.main}
                            color={theme.palette.background.dark}
                            startIcon={<Add />}
                            borderRadius={3}
                            handleClick={() => setAddOpen(true)}
                        />)}
                    </Box>
                }
                content={
                    parentList.length > 0 ? (parentList.map((a, index) => (
                        <CommonCard
                            key={index}
                            background={theme.palette.background.main}
                            borderRadius={2}
                            paddingBottom="0px"
                            padding="13px"
                            marginTop={index === 0 ? "0px" : "10px"}
                            content={
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center'
                                    }}
                                >
                                    <img src="/Images/parentAcces.png" alt="user" />
                                    <Box>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Typography fontWeight={600} fontSize={15}>{a?.user?.first_name}</Typography>
                                            <img alt="badge" src="/Images/verified-bagde.png" />
                                        </Box>
                                        <Typography fontSize={15} color={theme.palette.background.dark}>{a.relationship_type}-Read only</Typography>
                                    </Box>
                                </Box>
                            }
                        />
                    ))) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                        >
                            <Typography color={theme.palette.background.dark}>No Data Found</Typography>
                        </Box>
                    )}
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default ParentAccess;